<template>
  <div class="accountSetting securitySetting pl-xl-4">
    <h3 class="medium mb-4">Security</h3>
    <div class="border-bottom pb-4 mb-4">
      <h5 class="medium mb-2">Password</h5>
      <div class="d-flex align-items-center justify-content-between mob-wrap">
        <p class="mb-0 f-14"> Remember not to store your password in your email or cloud and don’t
          share it with anyone else </p>
        <router-link to="/change-password" class="flex-shrink-0 small cap_btn-b"
          >Change Password</router-link>
      </div>
    </div>
    <!-- <h5 class="border-bottom pb-4 mb-4">Phone Numbers</h5>
    <div class="card-body d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-start">
        <span class="iconSave"
          ><img
            src="../../../../../static/website/images/phoneCall.svg"
            alt="Phone"
            title="Phone Numbers"
        /></span>
        <div class="flex-shrink-0 ml-4">
          <h6 class="medium mb-0">
            {{ get_user.mobile_no ? get_user.mobile_no : "" }}
          </h6>
          <p class="my-1">Keep your primary phone number up-to-date</p>
          <p class="mb-0 green">Required</p>
        </div>
      </div>
      <router-link
        :to="{
          name: 'help_centre',
          params: {
            page: 'settings',
            ticketData: '1',
            method_id: '88',
          },
        }"
        class="flex-shrink-0 small cap_btn-b"
        >Manage</router-link
      >
    </div> -->
    <!-- <h3 class="medium border-bottom pb-4 mb-4">2-Step Verification</h3>
    <div class="mb-4">
      <h5 class="medium mb-2">Select your 2-step verification method</h5>
      <p>
        Your 2-step verification method is valid across all your Capital Wallet
        accounts
      </p>
    </div>
    <div class="card-body d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-start">
        <span class="iconSave"
          ><img
            src="../../../../../static/website/images/authenticator.png"
            alt="Phone"
            title="Phone Numbers"
        /></span>
        <div class="flex-shrink-0 ml-4">
          <h6 class="medium mb-0">Authenticator</h6>
          <p class="my-1">Time-based one-time 6-digit codes</p>
          <p class="mb-0 green">Secure</p>
        </div>
      </div>
      <a
        href="javascript:void(0)"
        @click="() => openModal('gauthModal')"
        class="flex-shrink-0 small cap_btn-b"
        >Disable</a
      >
    </div> -->
    <!-- <div class="border-bottom pb-3 mb-4">
            <h5 class="medium mb-2">Other options</h5>
        </div>
        <div class="card-body d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
                <span class="iconSave"><img src="../../../../../static/website/images/chatmesge.svg" alt="Phone" title="Phone Numbers"></span>
                <div class="flex-shrink-0 ml-4">
                    <h6 class="medium mb-0">Text Message</h6>
                    <p class="my-1">Phone number: +xx xxxxxx xx80</p>
                    <p class="mb-0 yellow">Moderately Secure</p>
                </div>
            </div>
            <a href="javascript:void(0)" class="flex-shrink-0 small cap_btn-b">Select</a>
        </div>
        <div class="card-body d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-start">
                <span class="iconSave"><img src="../../../../../static/website/images/2fa.svg" alt="Phone" title="Phone Numbers"></span>
                <div class="flex-shrink-0 ml-4">
                    <h6 class="medium mb-0">Security Key</h6>
                    <p class="my-1">Use your security key device</p>
                    <p class="mb-0 green">Very Secure</p>
                </div>
            </div>
            <a href="javascript:void(0)" class="flex-shrink-0 small cap_btn-b">Select</a>
        </div>
        <div class="verification">
            <h5>Require 2-step verification to send crypto:</h5>
            <p>Your 2-step verification method is valid across all your Capital Wallet accounts</p>
            <label class="customRadioButton">When Capital Wallet recommends it
                <input type="radio" name="radio">
                <span class="checkmark"></span>
            </label>
            <label class="customRadioButton">Any amount of cryptocurrency
                <input type="radio" name="radio">
                <span class="checkmark"></span>
            </label>
        </div> -->
    <!-- <div
      class="buttons d-flex align-items-center justify-content-end border-top pt-4 mt-4"
    >
      <a href="javascript:void(0)" class="cap_btn-b mr-3 min-auto">Cancel</a>
      <a href="javascript:void(0)" class="cap_btn small">Save</a>
    </div> -->

    <!-- Modal to diasble g-auth  -->
    <div
      class="modal fade"
      id="gauthModal"
      role="dialog"
      aria-labelledby="gauthModalTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            @click="() => closeModal('gauthModal')"
            type="button"
            class="close text-right pr-2"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body w-100">
            <div>
              <h5 class="">Google Authentication Code</h5>
              <div class="form-group">
                <input
                  type="text"
                  autofill="off"
                  autocomplete="cw"
                  class="form-control"
                  placeholder="******"
                  name="gauth"
                  v-model="gauth"
                />
                <span v-if="error && gauthError" class="text-danger">{{
                  gauthError
                }}</span>
              </div>
            </div>
            <div>
              <h5 class="">Password</h5>
              <div class="form-group">
                <input
                  type="text"
                  autofill="off"
                  autocomplete="cw"
                  class="form-control"
                  name="password"
                  v-model="password"
                />
                <span v-if="error && passwordError" class="text-danger">{{
                  passwordError
                }}</span>
              </div>
            </div>
            <div class="text-center my-4">
              <a
                @click="() => disable2FA()"
                href="javascript:void(0)"
                class="cap_btn lg mb-3"
                >Disable</a
              >
              <div>
                <small
                  ><strong>NOTE: </strong>You'll be logged out after disabling
                  g-auth and have to re-activate it upon login</small
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { registerStepsMixins } from "@/plugins/registerSteps";
import commonAllmixins from "@/plugins/commonAll";
// import editAddress from './edit_Address'
// import editNumber from './edit_Number'
export default {
  name: "accountprofile",
  mixins: [registerStepsMixins, commonAllmixins],
  data() {
    return {
      error: false,
      passwordError: "",
      gauthError: "",
      password: "",
      gauth: "",
      notification_msg: "",
      notification_type: "",
      // tab: '1',
      submitted: false,
      // editAddress: false,
      // editNumber: false,

      fname: "",
      mName: "",
      lname: "",
      dob: "",
      address: "",
      city: "",
      state: "",
      country: "",
      area_code: "",
      acc_type: "",
      OrganizationType: {
        0: "Company",
        1: "Self Managed Super Fund",
        2: "Discretionary/Unit Trust",
        3: "Others",
      },
    };
  },
  methods: {
    openModal(id, type) {
      this.error = null;
      this.modalType = type;
      let modal = document.getElementById(id);
      modal.classList.add("show");
    },
    closeModal(id) {
      this.modalType = null;
      let modal = document.getElementById(id);
      modal.classList.remove("show");
    },
    disable2FA() {
      this.error = false;
      if (this.gauth != "" && this.password != "") {
        this.gauthError = null
        this.passwordError = null
        let json = {
          globalParams: {
            otp: this.gauth,
            password: this.password,
          },
          localParams: {
            parameter: this,
          },
        };
        this._runDisable2FaQrcode(json);
      } else {
        this.error = true;
        if (this.gauth == "") {
          this.gauthError = "Please fill this field";
        } else {
          this.gauthError = null;
        }
        if (this.password == "") {
          this.passwordError = "Please fill this field";
        } else {
          this.passwordError = null;
        }
      }
    },
  },
  created() {
    this.pageName("Account Profile");
    if ("documents" in this.profileInfo) {
    } else {
      this._runGetProfileInfo({
        globalParams: {},
        localParams: {
          parameter: this,
        },
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/security.vue